import React, { useEffect } from 'react';
import Header from './Sections/header';
import Footer from './Sections/footer';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import CookieConsent from './Sections/cookies';
import WhatsappButton from '../Components/whatsapp';

interface MainProps {
    children: React.ReactNode;
    desc?: boolean;
}

const Main: React.FC<MainProps> = ({ children, desc = false }) => {
    useEffect(() => {
        window.scrollTo(0, 0)
    });
    
    return (
        <>
            {!desc && 
                <HelmetProvider>
                    <Helmet>
                        <meta name="description" content="Precursora na realização de eventos de profissões, compartilhamos informações relevantes para auxiliar na escolha da sua profissão. Vem com a gente!" />
                    </Helmet>
                </HelmetProvider>
            }
            
            <Header/>
            <main>
                {children}
            </main>
            <Footer/>
            <WhatsappButton />
            <CookieConsent />
        </>
    );
};

export default Main;